import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class TbbsDiagnosticsService {

  constructor(private http: HttpClient) { }

  /**
   * Save TBBS Diagnostics
   * Matches AngularJS: TbReclassDiaFactoryA.saveTBBS_Diagnostics
   * action_code: vl20dz (POST), process_name: Save_TBBS_DIAGNOSTICS
   */
  saveTBBSDiagnostics(
    baseUrl: string,
    rowData: any,
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=vl20dz`;

    const jsonObj = JSON.stringify(rowData);
    const jsonSettings = JSON.stringify({
      tax_year: filterParams.tax_year || '',
      scenario: filterParams.scenario || '',
      jcd_key: (globalParams.jcd_key === '' || !globalParams.jcd_key) ? 250 : globalParams.jcd_key
    });

    let params: any = _.merge({}, globalParams, filterParams);
    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = 'Save_TBBS_DIAGNOSTICS';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }
}
